import React from 'react';
import Layout from "../layout/layout";
import ContactHeader from "../components/Contact/contactHeader/contactHeader";

function Contact() {
    return (
        <Layout color={true}>
            <ContactHeader/>
        </Layout>
    );
}

export default Contact;